import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EditorialList } from '~app/modules/storyblok/models/storyblok-global-content.model';
import {
  EditorialLinkNavigationClickApplicationEvent
} from '~shared/modules/application-event/models/editorial-link-navigation-click-event.model';
import { ApplicationEventService } from '~shared/modules/application-event/services';

@Component({
  selector: 'app-editorial-link-list',
  templateUrl: './editorial-link-list.component.html',
  styleUrls: ['./editorial-link-list.component.scss'],
})
export class EditorialLinkListComponent {
  @Input() isMobile: boolean;
  @Input() editorialList: EditorialList;
  @Output() menuClosed = new EventEmitter<null>();

  constructor(private applicationEventService: ApplicationEventService) {}

  onLinkClick(link: string): void {
    this.menuClosed.emit();
    this.fireEditorialLinkNavigationClickEvent(link);
  }

  fireEditorialLinkNavigationClickEvent(link: string): void {
    this.applicationEventService.publish(new EditorialLinkNavigationClickApplicationEvent(link));
  }
}
